module.exports = __webpack_public_path__ + "files/e691879a23cba46d0ee48e0f43357ad4.svg";